module.exports = __webpack_public_path__ + "static/telegram-ffebadadbbf5640e7e55de58c81aa764.webp";